module.exports = __webpack_public_path__ + "static/media/infowatch.c8e0d133.png";